import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../createApiConfig'

export const AnalyticsApi = createApi({
  reducerPath: 'AnalyticsApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['Analytics', 'ReportRequests'],
  endpoints: builder => ({
    getNumberOfCampaigns: builder.query({
      query: params => ({
        url: '/analytics/number-of-campaigns/',
        params
      })
    }),

    getDetectedReportedRemoved: builder.query({
      query: ({ campaign_id }) => ({
        url: `/analytics/detected-reported-removed/`,
        params: { campaign_id }
      })
    }),

    getPerCustomerDetectedReportedRemoved: builder.query({
      query: params => ({
        url: `/analytics/per-customer-detected-reported-removed/`,
        params
      })
    }),

    getPerPlatformMonthDetectedReportedRemoved: builder.query({
      query: ({ campaign_id }) => ({
        url: `/analytics/per-platform-month-detected-reported-removed/`,
        params: { campaign_id }
      })
    }),

    getTopCampaignsDetectedReportedRemoved: builder.query({
      query: params => ({
        url: `/analytics/top-campaigns-detected-reported-removed/`,
        params
      })
    }),

    getDailyDetectedReportedRemoved: builder.query({
      query: params => ({
        url: `/analytics/daily-detected-reported-removed/`,
        params
      })
    }),

    getTopRemovals: builder.query({
      query: params => ({
        url: `/analytics/top-removals/`,
        params
      })
    }),

    getOpsPerformance: builder.query({
      query: params => ({
        url: `/analytics/ops-performance/`,
        params
      })
    }),

    getReportsOpsPerformance: builder.query({
      query: params => ({
        url: `/reports/ops-performance/`,
        params
      })
    }),

    getBackgroundTasks: builder.query({
      query: params => ({
        url: `/tasks/history/`,
        params
      })
    }),

    getReportRequests: builder.query({
      query: params => ({
        url: `/reports/requests/`,
        params
      }),
      providesTags: ['ReportRequests']
    }),

    submitReportRequest: builder.mutation({
      query: data => ({
        url: `/reports/requests/submit/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['ReportRequests']
    })
  })
})

export const {
  useGetNumberOfCampaignsQuery,
  useGetDetectedReportedRemovedQuery,
  useGetPerCustomerDetectedReportedRemovedQuery,
  useGetPerPlatformMonthDetectedReportedRemovedQuery,
  useGetTopCampaignsDetectedReportedRemovedQuery,
  useGetDailyDetectedReportedRemovedQuery,
  useGetTopRemovalsQuery,
  useGetOpsPerformanceQuery,
  useGetReportsOpsPerformanceQuery,
  useLazyGetReportsOpsPerformanceQuery,
  useGetBackgroundTasksQuery,
  useGetReportRequestsQuery,
  useLazyGetReportRequestsQuery,
  useSubmitReportRequestMutation
} = AnalyticsApi
